import CenteredSlider from "./variants/Centered";
import ContinousSlider from "./variants/Continous";
import DateRangeSelectionSlider from "./variants/DateRangeSelection";
import DiscreteSlider from "./variants/Discrete";
import RangeSelectionSlider from "./variants/RangeSelection";
const Slider = {
    RangeSelection: RangeSelectionSlider,
    Continous: ContinousSlider,
    Discrete: DiscreteSlider,
    Centered: CenteredSlider,
    DateRangeSelection: DateRangeSelectionSlider,
};
export default Slider;
